module.exports = __webpack_public_path__ + "static/logo-5a64a5d3ba9caa4f13b3fedf2d15aed3.png";